
  import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
  import {PaymentCategoryDto, ProjectDto, ProjectLedgerCreateOrUpdateDto} from "@/api/appService";
  import {ElForm} from "element-ui/types/form";
  import api from '@/api';
  import {createSelectTree} from "@/utils/tree";

  @Component({name:'ProjectLedgerEdit'})
  export default class ProjectLedgerEdit extends Vue{
    @Ref() readonly dataForm!: ElForm;

    @Prop({required:false})
    projectId?:number;

    @Prop({required:false})
    dataId?:number;

    projectList:ProjectDto[] = [];
    categoryList:PaymentCategoryDto[] = [];
    show:boolean = false;


    defaultData:ProjectLedgerCreateOrUpdateDto = {
      projectId:undefined,
      categoryId:undefined,
      amount:0,
      description:'',
      id:0,
      projectBudgetNo:'',
      occurrenceDate:new Date()
    };
    form:ProjectLedgerCreateOrUpdateDto | undefined = {...this.defaultData};


    async created(){
      console.log(this.form);
      await api.project.getAll({isAudited:true,maxResultCount:65535}).then(res=>{
        this.projectList = res.items!;
      });
      await api.paymentCategoryService.getAll().then(res=>{
        this.categoryList = createSelectTree(res.items!,'parentId','id',null,'displayName') ;
      });

    }

    get dialogTitle(){
      return (this.dataId)?'编辑':"新建";
    }

    @Watch('show')
    async onShowChange(value:boolean){
      if(value){
        if(this.dataId){
          await api.projectLedger.getForEdit({id:this.dataId}).then(res=>{
            this.form = res.data!;
          })
        } else {
          this.form = {...this.defaultData};
          if(this.projectId){
            this.form.projectId = this.projectId;
          }
        }
      } else {
        this.form = {...this.defaultData};
      }

      this.$nextTick(() => {
        // this.dataForm.clearValidate();
      });
    }

    async handleSave(){
      this.dataForm.validate(async (valid:boolean)=>{
        if(valid){
          if(this.form!.id){
            await api.projectLedger.update({body:this.form});
          } else {
            await api.projectLedger.create({body:this.form});
          }
          this.show = false;
          this.$message.success('更新成功');
        }
      });
    }

    cancel(){
      this.show = false;
    }

    public open(){
      this.show = true;
    }

    rule = {
      projectId:[
        {
          required:true,
          message:'项目是必须的',
          trigger:'blur'
        }
      ],
      amount:[
        {
          required:true,
          message:'金额是必须的',
          trigger:['change','blur']
        }
      ],
      description:[
        {required:false},
      ],
      occurrenceDate:[
        {
          required:true,
          message:'发生日期是必填项',
          trigger:['change','blur']
        }
      ],
      projectBudgetNo: [
        {
          max:50,
          message:'最大长度50个字符'
        }
      ]

    }

  }
